<svg xmlns="http://www.w3.org/2000/svg" width="12" viewBox="0 0 11 7" fill="none">
    <path d="M10 1L5.49999 6L1 1" stroke="#CAA75E" stroke-width="0.8" />
</svg>
